module.exports = __webpack_public_path__ + "img/weapon.c43b2737.png";